import CodeError from './components/CodeError';
import { useEffect } from 'react';
import { CircularIndeterminate } from '@utriper/core-ui';
import { useCheckout } from '../../core/contexts/checkout';
import { useTranslation } from '../../core/contexts/localization';
import { PaymentLinkStatus } from '@utriper/core';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentProcessing from './components/PaymentProcessing';
import CheckoutForm from './components/CheckoutForm';

const Checkout = () => {
    // CONTEXTS
    const { validateCheckout, getBookingItems, loading, paymentLink, bookingItems, paymentStatus, setAccessCode } = useCheckout();

    // VARIABLES
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const accessCode = params.get('code');
    const { t: translate } = useTranslation();

    // EFECTOS
    useEffect(() => {
        if (accessCode) {
            setAccessCode(accessCode);
            validateCheckout(accessCode);
        }
    }, []);

    useEffect(() => {
        if (accessCode && (paymentStatus === PaymentLinkStatus.IDS.opened || paymentStatus === PaymentLinkStatus.IDS.created || paymentStatus === PaymentLinkStatus.IDS.success) && paymentLink?.bookingCode) {
            getBookingItems(paymentLink.bookingCode);
        }
    }, [paymentStatus]);

    if (!accessCode) {
        return <CodeError />;
    }

    const renderCheckout = (status) => {
        switch (status) {
            case PaymentLinkStatus.IDS.created:
            case PaymentLinkStatus.IDS.opened:
                return <CheckoutForm />;
            case PaymentLinkStatus.IDS.processing:
                return <PaymentProcessing status={paymentStatus} accessCode={accessCode} />;
            case PaymentLinkStatus.IDS.expired:
                return <CodeError title={translate('checkout.codeError.expiredCode.title')} message={translate('checkout.codeError.expiredCode.message')} />;
            case PaymentLinkStatus.IDS.canceled:
                return <CodeError title={translate('checkout.codeError.canceledCode.title')} message={translate('checkout.codeError.canceledCode.message')} />;
            case PaymentLinkStatus.IDS.failed:
                return <CodeError title={translate('checkout.codeError.failedCode.title')} message={translate('checkout.codeError.failedCode.message')} />;
            case PaymentLinkStatus.IDS.success:
                return <PaymentSuccess redirectURL={paymentLink.callbackURL} userEmail={bookingItems[0]?.email} />;
            default:
                return <CodeError title={translate('checkout.codeError.invalidCode.title')} message={translate('checkout.codeError.invalidCode.message')} />;
        }
    };

    if (!loading && accessCode !== null && paymentStatus) return <div>{renderCheckout(paymentStatus)}</div>;

    return <CircularIndeterminate centered styles={{ marginLeft: '3em' }} />;
};

export default Checkout;
